import type { PropsWithChildren } from 'react';
import styled from 'styled-components';
import HomeButton from './HomeButton';

const HeaderBrand = ({children}: PropsWithChildren<{}>) => {
  return <HeaderBrandContainer>
    <HomeButton />
    {children}
  </HeaderBrandContainer>

}

const HeaderBrandContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
export default HeaderBrand;
